import { Component, OnInit } from "@angular/core";
import { take, finalize } from "rxjs/operators";
import { UserFacadeService } from "src/app/core/facades/userfacade/userfacade.service";
import { NgIf } from "@angular/common";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { RouterLink } from "@angular/router";
import { NowDirective } from "../../directives/now/now.directive";
import { TooltipDirective } from "ngx-bootstrap/tooltip";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-admin-dashboard",
  templateUrl: "./admin-dashboard.component.html",
  styleUrls: ["./admin-dashboard.component.scss"],
  imports: [
    NgIf,
    MatProgressSpinner,
    RouterLink,
    NowDirective,
    TooltipDirective,
    TranslatePipe,
  ],
})
export class AdminDashboardComponent implements OnInit {
  accounts;
  devices;
  isloading = true;
  count = {
    onlineDevices: 0,
    offlineDevices: 0,
    licenses: 0,
    validLicemses: 0,
    expiredInTenDaysLicenses: 0,
    expiredLicenses: 0,
    invoices: 0,
    customer: 0,
    resources: 0,
  };
  constructor(private userFacadeService: UserFacadeService) {}

  ngOnInit() {
    this.getCount();
  }

  getCount() {
    this.userFacadeService
      .getOrganisationSummary()
      .pipe(
        take(1),
        finalize(() => (this.isloading = false)),
      )
      .subscribe((s) => {
        this.count.onlineDevices = s.onlineDevices;
        this.count.offlineDevices = s.offlineDevices;
        this.count.resources = s.resources;
        this.count.customer = s.organizations;
        this.count.licenses = s.licenses;
        this.count.validLicemses = s.validLicemses;
        this.count.expiredInTenDaysLicenses = s.expiredInTenDaysLicenses;
        this.count.expiredLicenses = s.expiredLicenses;
        this.count.invoices = s.invoices;
      });

    /*getCount() {
    this.deviceService.getDevices().pipe(
      take(1),
      map(res => {
        const count: [] = res;
        this.count.devices = count.length;

      }),
      switchMap(() => {
        return this.licenseService.getLicenses().pipe(
          take(1),
          map(li => {
            const count: [] = li;
            this.count.licenses = count.length;
          }),
          switchMap(() => {
            return this.invoiceService.getInvoices().pipe(
              take(1),
              map(iv => {
                const count: [] = iv;
                this.count.invoices = count.length;

              })
            );
          }),
          switchMap(() => {
            return this.organizations.getOrganizations(this.organizations.organizationId.getValue()).pipe(
              take(1),
              map(ac => {
                const count: [] = ac;
                this.count.customer = count.length;
                this.isloading = false;
              })
            );
          })
        );
      })).subscribe();
  }*/
  }
}
